export default __webpack_public_path__ + "media/gcp_logo.7f4517c8.svg";